import classNames from 'classnames';
import { ButtonHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

type Variants =
  | 'secondary'
  | 'cancel'
  | 'large'
  | 'search'
  | 'fit'
  | 'contain'
  | 'delete';
export type ButtonProps = {
  variants?: Variants[];
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'style'>;

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variants = [], ...props }: ButtonProps, ref) => {
    const buttonClassNames = classNames(
      styles.button,
      ...variants.map((v) => styles[v])
    );
    let icon = <></>;
    if (variants.includes('search')) {
      icon = (
        <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.icon} />
      );
    }

    return (
      <button ref={ref} className={buttonClassNames} {...props}>
        {icon}
        {children}
      </button>
    );
  }
);
Button.displayName = 'Button';

export default Button;
